import { NormalStatus } from '@/constants/normal-status'
import { Creator } from '@/model/creator'
import { creatorSelector } from '@/redux/creator-adaptor'

import {
  createAppSelector,
  optionsInGroupCombiner,
} from './utils'

export const selectAccessibleCreators = createAppSelector([
  (state) => state.creator.creatorEntity,
  (state) => state.creator.permissionMap,
  (state) => state.global.permissionKey,
], (
  creatorEntity,
  permissionMap,
  permissionKey,
) => permissionMap[permissionKey]
  .map((id) => creatorSelector.selectById(creatorEntity, id))
   
  .filter((item): item is Creator => item !== undefined))

export const selectActivatedAccessibleCreators = createAppSelector([
  selectAccessibleCreators,
], (creators) => creators.filter(({ status }) => status === NormalStatus.Activated))

export const selectCreatorOptions = createAppSelector([
  selectAccessibleCreators,
  (state) => state.group.groups,
], optionsInGroupCombiner)